import {
  MainBanner,
  About,
  VisiMisi,
  Journey,
  AroundIndonesia,
  Awards,
  // OurProducts,
  Events,
  PremiumApps,
} from "../../components";

export default function AboutUs() {
  return (
    <>
      <MainBanner />
      <About />
      <VisiMisi />
      <Journey />
      <AroundIndonesia />
      <Awards />
      {/* <OurProducts /> */}
      <Events />
      <PremiumApps />
    </>
  );
}
